export default __webpack_public_path__ + "static/media/map-naver-img.cf84ed72.png";